import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiRequest } from '../../apiServices/allApi'
const $ = require('jquery')
$.Datatable = require('datatables.net')

export default function Running () {

  const id = localStorage.getItem('id')

  const [challenge, setchallenge] = useState()

  const fetchData = async () => {
  
    const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }
    try {
      const res = await apiRequest(  `challange/pending_challange`,"GET",null,headers);
      setchallenge(res.data)
      $('table').dataTable()

    } catch (error) {
      console.log(error.message);
    } finally {
      // setLoading(false)
    }
  };

  // const CancelGame = async id => {
  //   const confirm = window.confirm('are you sure to cancel')

  //   if (confirm == true) {
  //     const access_token = localStorage.getItem('token')
  //     const headers = {
  //       Authorization: `Bearer ${access_token}`
  //     }
  //     axios
  //       .patch(
  //         baseUrl + `challange/Cancel/${id}`,
  //         { Cancelled_by: access_token },
  //         { headers }
  //       )
  //       .then(res => {
  //         fetchData()
  //       })
  //   } else {
  //     window.alert('sorry try again')
  //   }
  // }

  const  CancelGame = async id => {
   const confirm = window.confirm('are you sure to cancel')

    if (confirm == true) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }
        
        const res = apiRequest( `challange/Cancel/${id}`,
          { Cancelled_by: access_token }, 'PATCH' , headers);
          fetchData()
      } else {
      
        window.alert('sorry try again')
      }
    }

  const dateFormat = e => {
    const date = new Date(e)
    const newDate = date.toLocaleString('default', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric'
    })
    return newDate
  }
  useEffect(() => {
    fetchData()
  }, [])

  if (challenge == undefined) {
    return null
  }

  return (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card'>
            <div className='card-body table_bg'>
              <h4 className='dashboard_heading'>Pending Challanges</h4>
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th>#</th>
                      {
                          id =="6931311e30989ed52eebce14" ?
                      <th> ID</th> : ""}
                      <th> Creator</th>
                      <th> Accepter</th>
                      <th> Amount </th>
                      <th> Status </th>
                      <th> Game Type </th>
                      <th>Date</th>
                      <th> Action </th>
                    </tr>
                  </thead>

                  <tbody>
                    {challenge &&
                      challenge.map((game, key) => (
                        <tr key={key}>
                          <td>{key + 1}</td>
                             {
                          id =="6931311e30989ed52eebce14" ?
                          <td>{game._id}</td> :""}
                          <td>
                            <span className='pl-2 '>
                              {game.Created_by.Name}
                            </span>
                          </td>

                          <td>
                            <span className='pl-2'>
                              {game.Accepetd_By ? game.Accepetd_By.Name : null}
                            </span>
                          </td>
                          <td>{game.Game_Ammount}</td>
                          <td className='text-primary font-weight-bold'>
                            {game.Status}
                          </td>
                          <td>{game.Game_type}</td>
                          <td>{dateFormat(game.createdAt).split(',')[0]} </td>
                          <td>
                            <Link
                              type='button'
                              className='btn btn-primary mx-1'
                              to={`/view/${game._id}`}
                            >
                              View
                            </Link>
                            {/* {game.Status != "cancelled" && game.Status != "completed" && game.Status != "conflict" && <button type='button' className="btn  mx-1 btn-danger" onClick={() => CancelGame(game._id)}>Cancel</button>} */}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
